export default {
    "LOGIN_PATIENT": "login-patient",
    "TERMINATE_SHEET": "terminate-sheet",
    "PATIENT_DATA": "patient-data",
    "LANGUAGE_SELECTED": "language-selected",
    "SHEET_GO_PREV": "sheet-go-prev",
    "SHEET_GO_NEXT": "sheet-go-next",
    "MODAL_WINDOW_SHOW": "modal-window-show"
  }